import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';

var _this = this;

import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { ApolloLink } from 'apollo-link';
import { RetryLink } from 'apollo-link-retry';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { persistCache } from 'apollo-cache-persist';

// This PersistentClient hook is created to be used instead of the regular apollo client
// The main difference is we are caching some of the data so if user is
// going back and fourth it will be a more seamless experience
// data is being cached in session storage to ensure no stale data
// will persist.

var usePersistentClient = function usePersistentClient(props) {
  var _useState = useState({
    client: null,
    loaded: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var fetchClient = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var cache, httpLink, retryLink, client;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cache = new InMemoryCache({
                dataIdFromObject: function dataIdFromObject(object) {
                  switch (object.__typename) {
                    case props.typeName:
                      return object[props.primaryKey]; // use `primaryKey` as the primary key

                    default:
                      return false; // fall back to `id` and `_id` for all other types
                  }
                }
              });
              httpLink = createHttpLink({
                uri: props.url
              });
              retryLink = new RetryLink();
              client = new ApolloClient({
                link: props.middlewareLink ? ApolloLink.from([retryLink, props.middlewareLink, httpLink]) : ApolloLink.from([retryLink, httpLink]),
                cache: cache,
                fetchOptions: {
                  mode: 'no-cors'
                }
              });
              _context.prev = 4;
              _context.next = 7;
              return persistCache({
                cache: cache,
                storage: window.sessionStorage,
                maxSize: 100000000
              });

            case 7:
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](4);

              // eslint-disable-next-line no-console
              console.error('Error restoring Apollo cache', _context.t0);

            case 12:

              setState({
                client: client,
                loaded: true
              });

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 9]]);
    }));

    return function fetchClient() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    fetchClient();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state;
};

usePersistentClient.propTypes = {
  url: PropTypes.string.isRequired,
  typeName: PropTypes.string.isRequired,
  primaryKey: PropTypes.string.isRequired,
  middlewareLink: PropTypes.object
};

export default usePersistentClient;